import * as z from "zod";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
  maxCharacters: (num) => `Máximo de ${num} caracteres`,
  exactCharacters: (num) => `Deve conter ${num} caracteres`,
  invalidUrl: "Link inválido",
};

const NotificationValidator = {
  title: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  description: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(500, {
      message: messages.maxCharacters(500),
    }),
  link: z
    .string({ message: messages.requiredField })
    .url({ message: messages.invalidUrl })
    .or(z.literal("")),
  start_at: z.string({ message: messages.requiredField }).nullable().optional(),
  finish_at: z
    .string({ message: messages.requiredField })
    .nullable()
    .optional(),
};

export default NotificationValidator;
